// 数组中去除属性是空的项
export function forData(Arrray) {
  for (var i = 0; i < Arrray.length; i += 1) {
    if (Arrray[i].childDeptList == null || Arrray[i].childDeptList.length === 0) {
      Arrray[i].childDeptList = null
    } else {
      forData(Arrray[i].childDeptList)
    }
    if (i === Arrray.length - 1) {
      return Arrray
    }
  }
}
export function forDatas(Arrray) {
  for (var i = 0; i < Arrray.length; i += 1) {
    if (Arrray[i].childDeptList == null || Arrray[i].childDeptList.length === 0) {
      delete Arrray[i].childDeptList
    } else {
      forData(Arrray[i].childDeptList)
    }
    if (i === Arrray.length - 1) {
      return Arrray
    }
  }
}



// 给数组child的空数组置空
export function filterChildNull(arr, childKey) {
  if (!arr || arr.length === 0) return;
  arr.forEach(items => {
    const childLength = (items[childKey] && items[childKey].length) || 0;
    if (childLength > 0) {
      items[childKey] = filterChildNull(items[childKey], childKey);
    } else {
      items[childKey] = null;
    }
  });
  return arr;
}


// deptChange(id,catalog){
//   //id 是要查找的节点  catalog是存放所有数据的
//     var temppath = [];//定义变量保存当前结果路径
//     try {
//       function getNodePath(node) {
//         temppath.push(node.deptName);
//         //找到符合条件的节点，通过throw终止掉递归
//         if (node.deptName== id) {
//           throw ("GOT IT!");
//         }
//         if (node.childDeptList && node.childDeptList.length > 0) {
//           for (var i = 0; i < node.childDeptList.length; i++) {
//             getNodePath(node.childDeptList[i]);
//           }
//           temppath.pop(); //当前节点的子节点遍历完依旧没找到，则删除路径中的该节点
//         }
//         else {
//           temppath.pop();//找到叶子节点时，删除路径当中的该叶子节点
//         }
//       }
//       getNodePath(catalog); //catalog 是所有数据
//     }
//     catch (e) {
//       var result = temppath.join(",");
//      // callback(result);
//     //console.log(result)
//       return result;
//     }
//  // };
// },
